import React from 'react';
import styles from './pagination.scss';
import Pagination from './pagination.js';

export const PaginationClassic = props =>
  <Pagination
    className={styles.large}
    activeClass={'button-color'}
    arrowClass={styles.arrow}
    innerClass={styles.inner}
    {...props}
  />;



// WEBPACK FOOTER //
// ./app/components/pagination/pagination-classic.js